import script from "./SideFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SideFilter.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./SideFilter.vue?vue&type=style&index=1&id=04279ede&lang=css"

const __exports__ = script;

export default __exports__